import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="global-footer">
      <div className="footer-content">
        <div className="footer-section">
          <p>&copy; 2025 ExamFlip. All rights reserved.</p>
        </div>
        
        <div className="footer-section">
          <div className="footer-links">
            <a 
              href="mailto:contact@examflip.com" 
              className="footer-link"
              aria-label="Contact us via email"
            >
              Contact Us
            </a>
            
            <a 
              href="https://www.youtube.com/@ExamFlip" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
              aria-label="Visit our YouTube channel"
            >
              YouTube
            </a>
            
            <a 
              href="https://x.com/ExamFlip" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
              aria-label="Follow us on X (Twitter)"
            >
              X (Twitter)
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
